export const DND_HANDLER_CLASSNAME = "dnd-handle";

export const PRIMARY_NAV_HIEGHT = 64;
